
import React from "react";
import TableActionButtons from "../../CommonComponents/TableActionButtons";
import EmptyState from "../../CommonComponents/EmptyState";
import { ShoppingCart } from "lucide-react";
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';

// Reusable empty state component
// Removed local definition of EmptyState



const PreReleaseCartTable = ({ items, products, startEdit, removeItem }) => (
    <div className="bg-white rounded-xl shadow border border-gray-100 overflow-hidden flex flex-col p-3 md:p-5 min-h-[500px]">
        <h3 className="font-semibold text-xs md:text-sm mb-2 text-brand-green tracking-tight uppercase letter-spacing-wide">2. Pre-Release Cart</h3>
        <div className="flex flex-col min-w-[120px]">
            {items.length > 0 ? (
                <>
                    <div className={tableContainer}>
                        <table className={tableBase + ' text-xs'}>
                            <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
                                <tr>
                                    <th className={tableHeader + ' text-left'}>Product</th>
                                    <th className={tableHeader + ' text-center'}>Qty</th>
                                    <th className={tableHeader + ' text-center'}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.filter(i => i.product_id && i.qty > 0).map((i, idx) => {
                                    const prod = products.find(p => p.id === i.product_id);
                                    if (!prod) return null;
                                    return (
                                        <tr key={i.product_id} className={tableRow + ' border-b last:border-0'}>
                                            <td className={tableCell + ' text-left'}>
                                                <div className="flex items-center gap-2">
                                                                                                        {prod.image && (
                                                                                                            <img
                                                                                                                src={prod.image}
                                                                                                                alt={prod.name}
                                                                                                                className="w-5 h-5 object-cover rounded-full border border-gray-200"
                                                                                                                onError={e => {
                                                                                                                    e.target.onerror = null;
                                                                                                                    e.target.src = "/default-product.png";
                                                                                                                }}
                                                                                                            />
                                                                                                        )}
                                                    <div>
                                                        <div className="font-semibold text-xs">{prod.name}</div>
                                                        {prod.description && prod.description !== prod.name && (
                                                            <div className="text-xs text-gray-500 max-w-xs truncate">{prod.description}</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className={tableCell + ' text-center'}>
                                                <span className="inline-block px-2 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-semibold border border-blue-100">{i.qty}</span>
                                            </td>
                                            <td className={tableCell + ' text-center'}>
                                                <TableActionButtons
                                                    canEdit
                                                    canDelete
                                                    onEdit={() => startEdit(idx)}
                                                    onDelete={() => removeItem(i.product_id)}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-2 flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 text-xs font-semibold">
                        <span>Total</span>
                        <span className="text-blue-700">{items.reduce((sum, i) => sum + i.qty, 0)}</span>
                    </div>
                </>
            ) : (
                <EmptyState icon={ShoppingCart} message="No products added yet." />
            )}
        </div>
    </div>
);

export default PreReleaseCartTable;
